import CrossIcon from '/public/s2_icon_cross_small.svg'
import styles from '@styles/components/FireflyToast.module.scss'

type Props = {
  onClick?: () => void
}

export function FireflyToastCloseButton({ onClick }: Props) {
  return (
    <button className={styles['close-button']} onClick={onClick}>
      <CrossIcon />
    </button>
  )
}
